export const SPOTIFY_PLAYBACK_EVENT = 'spotify-playback';

export type PlaybackTelemetryEvent = {
  type: string;
  message?: string;
  trackId?: string | null;
  deviceId?: string | null;
  source?: string;
  [key: string]: unknown;
};

const isDevelopment = typeof process !== 'undefined' && process.env.NODE_ENV !== 'production';

export function emitPlaybackTelemetry(event: PlaybackTelemetryEvent): void {
  try {
    const detail = { timestamp: Date.now(), ...event };
    if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
      window.dispatchEvent(new CustomEvent(SPOTIFY_PLAYBACK_EVENT, { detail }));
    }
    if (isDevelopment) {
      console.debug('[spotify-playback]', detail);
    }
  } catch (error) {
    if (isDevelopment) {
      console.warn('Failed to emit spotify-playback event', error);
    }
  }
}
